// extracted by mini-css-extract-plugin
module.exports = {"text":"AffirmPrice_text__o0FxN"};